import { gsap } from 'gsap';

const animations = {};

animations.scaleYfromBottom = (element) => {
    gsap.fromTo(element, {
        duration: 1,
        transformOrigin: 'center top',
        scaleY: 1.05,
        y: 20,
        autoAlpha: 0,
    }, {
        duration: 1,
        scaleY: 1,
        y: 0,
        autoAlpha: 1,
        ease: 'power3.out',
    });
};

animations.fadeUp = (element) => {
    gsap.to(element, {
        duration: 1,
        y: 0,
        autoAlpha: 1,
        delay: (element.dataset.delay !== undefined ? parseFloat(element.dataset.delay) : 0.1),
        onStart: () => {
            // trigger anims
            if (element.dataset.trigger !== undefined) {
                animations.trigger(element);
            }
        },
    });
};

animations.triggerStaggerUp = (element) => {
    gsap.to(element.querySelectorAll('[data-trigger]'), {
        duration: 1,
        y: 0,
        autoAlpha: 1,
        delay: (element.dataset.delay !== undefined ? parseFloat(element.dataset.delay) : 0.1),
        stagger: (element.dataset.speed !== undefined ? parseFloat(element.dataset.speed) : 0.125),
    });
};

export default animations;
